import colors from "@constants/colors"
import { Box, Text, css, useTheme } from "@chakra-ui/react"
import { bp } from "@utils/MediaQueries"

export interface NoResultsProps {}

const NoResults: React.FC<NoResultsProps> = () => {
  const theme = useTheme()
  const styles = css({
    width: "100%",
    flexDir: "column",
    alignItems: "center",
    justifyContent: "center",
    display: "flex",
    height: bp("auto", null, "100vh"),
    paddingTop: bp("8rem", null, "0"),
    paddingX: bp("1.25rem", null, "0"),
    fontFamily: "Avenir",
    header: {
      fontWeight: "800",
      fontSize: bp("23px", null, "33px"),
      color: colors.midAccessible,
    },
    p: {
      fontSize: bp("16px", null, "19px"),
      width: bp("100%", null, "calc(7.75/16 *100vw)"),
      textAlign: "center",
      paddingY: "1rem",
    },
  })(theme)

  return (
    <Box css={styles}>
      <Text as="header">No items match your search</Text>
      {/* <Text>
        Amet minim mollit non deserunt ullamco est sit aliqua dolor do amet
        sint. Velit officia consequat duis enim velit mollit. Exercitation
        veniam consequat sunt nostrud amet. Amet minim mollit non deserunt
        ullamco est sit aliqua dolor do amet sint.
      </Text> */}
    </Box>
  )
}

export default NoResults
